import { render, staticRenderFns } from "./MyNav.vue?vue&type=template&id=39ca1e8a&scoped=true"
import script from "./MyNav.vue?vue&type=script&lang=js"
export * from "./MyNav.vue?vue&type=script&lang=js"
import style0 from "./MyNav.vue?vue&type=style&index=0&id=39ca1e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca1e8a",
  null
  
)

export default component.exports